'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('../../transport/transport.js');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Pages {
  get(params) {
    return __async(this, null, function* () {
      const page = yield transport.transport.request("pages/get", params);
      if (!page) {
        const { slug, lang } = params;
        throw new Error(`Page '${slug}' not found for '${lang}' language`);
      }
      return page;
    });
  }
}

exports.Pages = Pages;
